import React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';

export interface PersistentDialogProps extends Omit<DialogProps, 'onClose'> {
  strictClose?: boolean;
  onClose?: DialogProps['onClose'];
}

export const PersistentDialog: React.FC<PersistentDialogProps> = ({ strictClose = true, onClose, ...dialogProps }) => {
  const handleClose: DialogProps['onClose'] = (event, reason) => {
    if (!strictClose || (reason !== 'backdropClick' && reason !== 'escapeKeyDown')) {
      onClose?.(event, reason);
    }
  };

  return <Dialog {...dialogProps} onClose={handleClose} />;
};
